<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image poc-net-splash" v-if="!isMobile()">
                                        <img alt="Push to talk over cellular splash" src="./assets/poc-splash.svg">
                                    </figure>
                                    <figure class="image poc-net-splash mobile-screen" v-else>
                                        <img alt="Push to talk over cellular splash" src="./assets/poc-splash.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-1x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('poc-network-description:poc-network-description.subtitle') }}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Push to talk section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('poc-network-description:poc-network-description.ptt_title_up')">
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                     <div class="column content column-center">
                        <figure class="image img-500" v-if="!isMobile()">
                            <img alt="What is PTT?" src="./assets/ptt-describe-white.svg">
                        </figure>
                        <figure class="image img-400 mobile-screen" v-else>
                            <img alt="What is PTT?" src="./assets/ptt-describe-white.svg">
                        </figure>
                     </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc-network-description:poc-network-description.ptt_description') }}
                        </p>
                    </div>
                </div>

            </div>
        </section>

        <!-- Cellular section -->
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center"
                            v-html="$t('poc-network-description:poc-network-description.cellular_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7">
                            {{ $t('poc-network-description:poc-network-description.cellular_description1') }}
                        </p>
                    </div>
                </div>

                <div class="columns is-centered">
                     <div class="column content column-center">
                        <figure class="image img-400" v-if="!isMobile()">
                            <img alt="Emerging 3G and 4G" src="./assets/radio-to-cellular.svg">
                        </figure>
                        <figure class="image img-400 mobile-screen" v-else>
                            <img alt="Emerging 3G and 4G" src="./assets/radio-to-cellular.svg">
                        </figure>
                     </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7">
                            {{ $t('poc-network-description:poc-network-description.cellular_description2') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- PoC applications section -->
        <section class="section is-background-dark1">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center text-yellow"
                            v-html="$t('poc-network-description:poc-network-description.poc_applications_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc-network-description:poc-network-description.poc_applications_desc1') }}
                        </p>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image img-600 poc-applications-img" v-if="!isMobile()">
                            <img alt="Push to talk applications" src="./assets/ptt-applications-white.svg">
                        </figure>
                        <figure class="image img-600 mobile-screen" v-else>
                            <img alt="Push to talk applications" src="./assets/ptt-applications-white.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container is-paddingless">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7 text-white">
                            {{ $t('poc-network-description:poc-network-description.poc_applications_desc2') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- Uptin PoC section-->
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center"
                            v-html="$t('poc-network-description:poc-network-description.uptin_poc_title')">
                        </h3>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column content column-center">
                        <figure class="image img-600" v-if="!isMobile()">
                            <img alt="Uptin PoC" src="./assets/uptin-poc.svg">
                        </figure>
                        <figure class="image img-600 mobile-screen" v-else>
                            <img alt="Uptin PoC" src="./assets/uptin-poc.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns is-centered">
                    <div class="column intro-text content small-container">
                        <p class="small-container uptin-text-center uptin-text-7">
                            {{ $t('poc-network-description:poc-network-description.uptin_poc_description') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <pay-as-you-go></pay-as-you-go>
    </div>
</template>

<style lang="scss">
    .poc-net-splash {
        max-width: 800px;
        min-width: 800px;
        margin: 2%;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"

    export default {
        components: {
            PayAsYouGo
        },
        name: 'poc-network-description',
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        }
    }
</script>
